<template>
  <button
    class="btn btn-primary mt-2 text-white"
    :disabled="
      checked === false ||
        tipoCDP == 0 ||
        (tipoCDP == 2 && (ruc.length != 11 || razsoc == '' || facdir == ''))
    "
    v-on:click="clickToPayWithNiubiz()"
  >
    Pasar a pagar con tarjeta(Niubiz)
  </button>
</template>

<script>
import toastr from 'toastr';
import { config_settings } from '@/config.js';
import { getVisaAuth, getVisaSessionId } from '@/service/visanet.service';
import { setNiubizSecurityToken, setCdpDetailsForVisanet } from '@/helpers/localStorage.helpers';

export default {
  name: 'NiubizPaymentButton',
  props: [
    'configData',
    'checked',
    'tipoCDP',
    'ruc',
    'razsoc',
    'facdir',
    'loggedUserData',
    'totalValue',
  ],
  data() {
    return {
      isProdEnviorment: config_settings.PROD_ENV,
      niubizSessionKey: '',
      visaSesionKey: '',
      clientIp: '',
      channel: 'web',
    };
  },
  methods: {
    clickToPayWithNiubiz() {
      if (this.loggedUserData) {
        if (this.loggedUserData.dni_client === '' || this.loggedUserData.phone_client === null) {
          this.$parent.setErrorMessage(
            'Debe ingresar sus datos completos para poder realizar una compra. Actualize todos sus datos <a href="/perfil">aquí</a> e inténtelo nuevamente.',
          );
        } else {
          if (this.tipoCDP == 1) {
            var json_cdp = {
              factura: false,
              ruc: '',
              companyName: '',
              billing_address: '',
            };
          } else {
            var json_cdp = {
              factura: true,
              ruc: this.ruc,
              companyName: this.razsoc,
              billing_address: this.facdir,
            };
          }
          setCdpDetailsForVisanet(json_cdp);
          this.visanetGetToken();
        }
      } else {
        toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
          iconClass: 'customer-danger',
        });
        this.$parent.setErrorMessage('Debe iniciar sesión antes de continuar');
        this.$router.push({ path: '../../login/' });
      }
    },

    visanetGetToken() {
      getVisaAuth(this.configData)
        .then((response) => {
          this.niubizSessionKey = response.data;
          setNiubizSecurityToken(this.niubizSessionKey);
          this.visanetGetSesionid();
        })
        .catch((error) => {
          this.$parent.setErrorMessage('Error al autenticar el comercio en niubiz');
        });
    },

    visanetGetSesionid() {
      fetch('https://api.ipify.org?format=json')
        .then((x) => x.json())
        .then(({ ip }) => {
          this.clientIp = ip;
        });

      var regDateClient = new Date(this.loggedUserData.reg_date_client);
      var currentDate = new Date();
      var timeDifference = currentDate - regDateClient;
      var daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      var jsonObject = {
        amount: this.totalValue,
        channel: this.channel,
        antifraud: {
          clientIp: this.clientIp,
          merchantDefineData: {
            MDD4: this.loggedUserData.email_client,
            MDD21: 0,
            MDD31: this.loggedUserData.phone_client,
            MDD32: this.loggedUserData.nick_client,
            MDD33: 'DNI',
            MDD34: this.loggedUserData.dni_client,
            MDD75: 'Registrado',
            MDD77: daysDifference,
          },
        },
      };

      getVisaSessionId(jsonObject, this.niubizSessionKey, this.configData)
        .then((response) => {
          this.visaSesionKey = response.data.sessionKey;
          this.openVisanetCheckoutModal();
        })
        .catch((error) => {
          this.$parent.setErrorMessage('Error al obtener el key de sesión de niubiz');
        });
    },

    openVisanetCheckoutModal() {
      var sessionToken = this.visaSesionKey;
      var amountTotal = this.totalValue;
      var isProdEnviorment = this.isProdEnviorment;
      var ecommerceConfigData = this.configData;
      var channel = this.channel;
      var brand = ecommerceConfigData.general.brandName;
      var merchantId = isProdEnviorment
        ? ecommerceConfigData.ecommerceProps.paymentMethods.niubiz.cdnProdWebMode.merchantId
        : ecommerceConfigData.ecommerceProps.paymentMethods.niubiz.cdnTestWebMode.merchantId;
      var actionLink = isProdEnviorment
        ? ecommerceConfigData.ecommerceProps.paymentMethods.niubiz.cdnProdWebMode.action
        : ecommerceConfigData.ecommerceProps.paymentMethods.niubiz.cdnTestWebMode.action;

      var tokenSubstrack = this.niubizSessionKey.replace(/\D/g, '').slice(-12);

      VisanetCheckout.configure({
        sessiontoken: sessionToken,
        channel: channel,
        merchantid: merchantId,
        merchantname: brand,
        formbuttoncolor: '#007bff',
        purchasenumber: tokenSubstrack,
        amount: amountTotal,
        expirationminutes: '15',
        timeouturl: 'https://www.armasperu.com.pe/timeout',
        merchantlogo: 'http://localhost:8080/img/logo.8e0a3b0b.png',
        action: actionLink,
        complete: function(params) {
          alert(JSON.stringify(params));
        },
      });
      VisanetCheckout.open();
    },
  },
};
</script>
